require('@uswds/uswds');

let wdfnviz = {};

let load = function(onLoadFnc) {
    // NOTE: Here we use a try/catch block rather than a global "onerror"
    // handler, because Babel's polyfills strip some of the exception data out.
    // This method retains access to the exception object.
    try {
        onLoadFnc();
    } catch (err) {
        // Send exception to Google Analytics.
        if (window.ga) {
            window.ga('send', 'exception', {
                // exDescription will be truncated at 150 bytes
                exDescription: err.stack,
                exFatal: true
            });
        }
        throw err;
    }
};

wdfnviz.main = function(onLoadFnc) {
    if (document.readyState !== 'loading') {
        load(onLoadFnc);
    } else {
        document.addEventListener('DOMContentLoaded', function() {
                load(onLoadFnc);
            }, false
        );

    }
};

module.exports = wdfnviz;